import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

/**
 * The Expenses tab body (SWOOP-222 / 104), rendered inside the vehicle-profile layout at
 * `/vehicles/$vehicleId/overview/expenses`. Unlike its sibling tabs (which inherit only `vehicles:list`
 * from the layout), consulting expenses needs the dedicated `expenses:list` permission, so this route
 * adds its own guard and redirects to the Overview tab when the user lacks it.
 */
export const Route = createFileRoute('/_authenticated/vehicles_/$vehicleId_/overview/expenses')({
  beforeLoad: ({ context, params }): void => {
    if (context.permissions.isReady && !context.permissions.hasPermission('expenses:list')) {
      throw redirect({ params: { vehicleId: params.vehicleId }, to: '/vehicles/$vehicleId/overview' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/vehicles/pages/vehicle-expenses-page')),
  staticData: { titleKey: 'vehicleExpenses' },
});
